import React from "react"
import "./Tak.css"

const Tak = props => {
  console.log("LOADING TAK")

  return (
    <div className="Tak">
      <div className="header-wrapper">
        <div className="header-top">
          <img src="/icons/apple-icon-72x72.png" />
          <div className="header-title">
            <h3>Tilmelding til Karate-træning i Skovbo Karate Klub</h3>
          </div>
        </div>
        <div className="welcome">
          <h2>Din indmeldelse er registreret</h2>
          <p>Du skal ikke foretage dig yderligere. Vi ses til træning!</p>
          <p>Oss!!</p>
          <p>Hvis du vil se mere om klubben så klik dig ind på nedenstående...</p>
          <div className="links">
            <p>
              <a href="http://skovbokarate.dk" target="_blank">
                Skovbo Karate Klubs hjemmeside.
              </a>
            </p>
            <p>
              <a href="https://www.facebook.com/SkovboKarate/?ref=bookmarks" target="_blank">
                Skovbo Karate Klubs Facebook side
                <br />
                Seneste nyheder findes her!
              </a>
            </p>
            <p>
              <a href="https://www.facebook.com/groups/skovbokarate/?source_id=133402523472275" target="_blank">
                Skovbo Karate Klubs Facebook gruppe
                <br />
                Alle medlemmer kan komme med indlæg!
              </a>
            </p>
            <p>
              <a href="http://www.jundokan.dk" target="_blank">
                Skovbo Karate Klub er medlem af Jundokan Danmark
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Tak
